import { typographyStyles } from "@newsela/angelou";

// Static poll styles
export const staticPollOptionsCss = {
  listStyle: "none",
  margin: 0,
  padding: 0,
  width: "100%",
};

export const staticPollOptionCss = {
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  marginBottom: "32px",
};

// Interactive poll styles
export const interactivePollOptionsCss = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

// Style used by all the different poll option types
export const pollOptionTextCss = [
  {
    borderRadius: "4px",
    display: "block",
    fontWeight: 700,
    maxWidth: "600px",
    padding: "8px 16px",
    width: "100%",
  },
  typographyStyles.textM,
];
